import { apiGroup } from '../http';

var _apiGroup = apiGroup({
  name: 'BridgeModelMapping',
  dataOption: 'bridgeModelMapping',
  plural: {
    requiredOptions: ['modelName'],
    url: function url(_ref) {
      var modelName = _ref.modelName;
      return "/models/".concat(modelName, "/mappings");
    },
    transform: function transform(response) {
      return {
        bridgeModelMappings: response.data.mappings
      };
    }
  },
  singular: {
    requiredOptions: ['modelName', 'mappingName'],
    url: function url(_ref2) {
      var modelName = _ref2.modelName,
          mappingName = _ref2.mappingName;
      return "/models/".concat(modelName, "/mappings/").concat(mappingName);
    },
    transform: function transform(response) {
      return {
        bridgeModelMapping: response.data.mapping
      };
    }
  }
}),
    fetchBridgeModelMappings = _apiGroup.fetchBridgeModelMappings,
    fetchBridgeModelMapping = _apiGroup.fetchBridgeModelMapping,
    createBridgeModelMapping = _apiGroup.createBridgeModelMapping,
    updateBridgeModelMapping = _apiGroup.updateBridgeModelMapping,
    deleteBridgeModelMapping = _apiGroup.deleteBridgeModelMapping;

export { fetchBridgeModelMappings, fetchBridgeModelMapping, createBridgeModelMapping, updateBridgeModelMapping, deleteBridgeModelMapping };